import { Component, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { LoggedUser } from '../auth/interfaces/logged-user';
import { jwtDecode } from 'jwt-decode';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';

import { ProgressSpinnerComponent } from './components/utility-components/progress-spinner/progress-spinner.component';
import { AuthService } from '../auth/services/auth.service';
//import { FailedNotebookBannerService } from './services/failed-notebook-banner.service';


@Component({
  standalone: true,
    selector: 'app-root',
    imports: [
        CommonModule,
        RouterOutlet,
        HeaderComponent,
        FooterComponent
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'desp';
  isLoading = true; // flag for showing progress spinner
  loggedUser: any | null = null;
  private destroy$ = new Subject<void>();
 //failedMessage$: Observable<string | null>;

  constructor(
    //private router: Router,
   // private http: HttpClient,
    private authService: AuthService,
    //private bannerService: FailedNotebookBannerService
  ) {
   // this.failedMessage$ = this.bannerService.banner$;
  }

  ngOnInit() {
    //get loggedUser
    this.loggedUser = this.authService.getLoggedUserLocalStorage();
   // console.log("decoded: ",this.loggedUser);
    this.authService.getTokenNoAsync();
  
  // this.decodeToken();
     //console.log("Logged user: ",this.loggedUser);
    if (!this.loggedUser) {
      this.decodeToken();
    }
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  decodeToken() {
    this.authService.getTokenNoAsync().then((token) => {
      this.loggedUser = jwtDecode(token);
      console.log("Decoded: ",this.loggedUser);
      this.authService.setLoggedUserOnLocalStorage(token);
      this.authService.setUserIdFromToken();
    });
  }
    dismiss(): void {
   // this.bannerService.dismiss();
  }
}
